mainApp.component('bgpSettings',{
    templateUrl: '/public/components/bgpSettings.html',
    bindings: {
        bgpNeighbors : '=',
        deleteItems : '&',
        siteId: '=',
        isSocketSite: '<'
    },
    controller: bgpSettingsController
});

function bgpSettingsController($scope, $sce, GeneralUtilsService, $timeout){
    var $ctrl = this;

    $ctrl.$onInit = function() {
         $ctrl.original = angular.copy($ctrl.bgpNeighbors);
         $ctrl.tableDataModified = false;
    }

     //notify the table if the site was changed and table needs to be reloaded
     $scope.$on('modelReloadedEvent', function (event, data) {
            $ctrl.tableDataModified = new Date().getTime();
            $ctrl.original = angular.copy($ctrl.bgpNeighbors);
        });

    $scope.bgpTableConfig = {
        dataURL : function(){ return null;},
        fields : [ {'label':'','path':'item','template':'<bgp-neighbor is-socket-site="tableConfig.isSocketSiteFamily()" neighbor="item" last-index="tableConfig.getLastIndex()"></bgp-neighbor>'}],
        alternativeHead: [
            {'label': 'Description', 'path': '', noSort: true},
            {"label":$sce.trustAsHtml("ASN Settings <div class='more-info asn-tooltip' data-toggle='tooltip' data-placement='bottom' title='AWS configuration requires similar ASN number for all peers'><span class='glyphicon glyphicon-question-sign'></span></div>"), "labelType":"html","path":""},
            {'label': 'IPs', 'path': '', noSort: true},
            {'label': 'Routing', 'path': '', noSort: true},
            {'label': 'Additional', 'path': '', noSort: true}
        ],
        addAction : function(){
            var newItem = {
                id: GeneralUtilsService.getRandomId(),
                name: "",
                neighborMetric: 100,
                holdTime: 60,
                keepaliveInterval: 20
            };
            this.items.push(newItem);
            $ctrl.tableDataModified = new Date().getTime();
        },
        parseData: function(){
            return $ctrl.bgpNeighbors;
        },
        onSelect: function(index) {

        },
        multiSelect: true,
        deselect: true,
        noAutoSelect: true,
        selectedItems:[],
        actions: [],
        hideCheckboxes: true,
        specialActions:[{
            func: function(selectedItems, config) {
                var itemsToDelete = [];

                    selectedItems.forEach(function(item) {
                        for (var i = 0 ; i < $ctrl.bgpNeighbors.length; i++) {
                            var neighbor = $ctrl.bgpNeighbors[i];
                            if (item.id === neighbor.id) {
                                $ctrl.bgpNeighbors.splice(i, 1);
                                if (item.id > 0) {
                                itemsToDelete.push(neighbor);
                                    break;
                                 }
                            }
                        }
                });
                config.selectedItems.length = 0;
                $ctrl.deleteItems({items: itemsToDelete, propertyName: 'bgpNeighbors'});
                $ctrl.tableDataModified = new Date().getTime();
            },
            icon: "delete",
            tooltip: "Delete"}
        ],
        noSearch:true,
        pageSize:4,
        //clientSideSearch and clientSideSort are needed for paging to work correctly
        clientSideSearch: true,
        clientSideSort: true,
        clientSidePaging: true,
        keepPageOnRefresh: true,
        isSocketSiteFamily: () => {
            return $ctrl.isSocketSite;
        },
        getLastIndex : function(){
            return $ctrl.bgpNeighbors.length;
        }

    };

    //get BGP status for all peers from pop
    $ctrl.showSiteBGPStatus = function() {
        store.fetch({
            path: '/showSiteBGPStatus',
            queryParams: {siteId: this.siteId},
            success: function (data) {
                if(data && data.status && data.status == "ERROR"){
                  $scope.$root.handleServerResponse(data, "" , "");
                }
                else if(data){
                    delete $scope.$root.errors['bgpShowStatusError'];
                    $ctrl.bgpStatuses = findNeighborForStatusAndAddDesc(data.statuses);
                    $ctrl.bgpRawStatuses = data.rawStatuses;

                     $timeout(function() {
                         $scope.$root.openPopup('bgpStatusDetails');
                    });
                }
            }
        });
    }

     //close the show BGP status pop up
    $ctrl.closeBgpStatusPopup = function () {
        $scope.$root.closePopup('bgpStatusDetails');
    };

     //close the show Copy Configuration pop up
        $ctrl.closeCopyConfigurationPopup = function () {
            $scope.$root.closePopup('bgpCopyConfiguration');
        };

        $ctrl.copyBgpConfiguration = function(){
            $scope.$root.openPopup('bgpCopyConfiguration');
        }

    //check if BGP table has unsaved changes
    $ctrl.tableHasChanges = function() {
        return !angular.equals($scope.bgpTableConfig.items, $ctrl.original);
    }

    //matches neighbor IP in status to neighbor IP in table items ad adds the neighbor description to status
    //returns only statuses on neighbors found in table
    function findNeighborForStatusAndAddDesc(statuses) {
        var matchedStatuses = [];

        statuses.forEach(function(status){
            $ctrl.bgpNeighbors.forEach(function(neighbor){
                if(neighbor.neighborIp === status.Remote_IP){
                    status.description = neighbor.description;
                    matchedStatuses.push(status);
                }

            });
        });
        return matchedStatuses;
    }
}
